import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileFiltersModalComponent } from './mobile-filters-modal.component';
import { PageScrollingService } from '@shared/services/page-scrolling';

@NgModule({
  declarations: [MobileFiltersModalComponent],
  exports: [MobileFiltersModalComponent],
  imports: [CommonModule],
  providers: [PageScrollingService],
})
export class MobileFiltersModalModule {}
